import React from 'react';
import type { EmitChangedFavorite } from '@atlassian/jira-favourite-change-provider/src/model/types.tsx';
import { useChangeFavorite } from '@atlassian/jira-favourite-change-provider/src/view/FavoriteChangeConsumer.tsx';
import { useFlagService } from '@atlassian/jira-flags';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import type { CopyModalProps } from '../common/types.tsx';
import FilterDataProvider from '../services/filter-data-provider/index.tsx';
import Content from './content/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

function CopyModal(props: CopyModalProps): React.JSX.Element {
	const { id, onDataRetrieveFailed } = props;
	const flagService = useFlagService();
	const intl = useIntl();
	const isAdmin = useIsAdmin();

	let emitChangedFavorite: EmitChangedFavorite = noop;
	const hookValue = useChangeFavorite();
	emitChangedFavorite = hookValue.emitChangedFavorite;

	return (
		<FilterDataProvider
			id={id}
			flagService={flagService}
			onDataRetrieveFailed={onDataRetrieveFailed}
			isAdmin={isAdmin}
		>
			{({ error, data }) => {
				if (error) {
					return null;
				}

				return data ? (
					<Content
						emitChangedFavorite={emitChangedFavorite}
						intl={intl}
						flagService={flagService}
						filter={data}
						isAdmin={isAdmin}
						{...props}
					/>
				) : null;
			}}
		</FilterDataProvider>
	);
}

export default CopyModal;
